/* Almla: no discount code unless the shopper types one (client feedback,
   Oct 13: an affiliate code the shopper had looked at once was still applied
   in her cart). Loaded by both layouts, so it runs on every page.

   Shopify keeps a code from a /discount/CODE link or a ?discount=CODE address
   in the cart and in a discount_code cookie (which checkout also reads).
   Affiliate apps apply theirs the same way: GoAffPro fetches
   /discount/CODE when someone lands from an affiliate link. So on every page
   load, and again just before going to checkout, this expires the cookie and
   takes the codes off the cart.

   Codes typed at checkout live on the cart too. A shopper who types one and
   then comes back to the shop keeps it: codes on the cart when the previous
   page was checkout are remembered in this browser and left alone.

   Automatic discounts (the Rebuy bundle tiers) are not codes and are not
   touched. */
window.AlmNoCode = (function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var KEY = "alm_typed_codes";
  function typed() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function expireCookie() {
    if (document.cookie.indexOf("discount_code=") < 0) return;
    var host = location.hostname, parts = host.split(".");
    var doms = ["", "; domain=" + host, "; domain=." + host];
    if (parts.length > 2) doms.push("; domain=." + parts.slice(-2).join("."));
    doms.forEach(function (d) {
      document.cookie = "discount_code=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT" + d;
    });
  }
  function clean() {
    // Checkout (same origin, full referrer) or Shop Pay (shop.app, origin only).
    var fromCheckout = /\/checkouts?\/|^https:\/\/shop\.app\//.test(document.referrer || "");
    // Codes known to come from links (Shopify's cookie, GoAffPro's dcode) are never remembered as typed.
    var linked = ["discount_code", "dcode"].map(function (n) {
      var m = new RegExp("(?:^|; )" + n + "=([^;]*)").exec(document.cookie);
      try { return m ? decodeURIComponent(m[1]).toLowerCase() : ""; } catch (e) { return ""; }
    });
    expireCookie();
    return fetch(ROOT + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = (c.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        if (!codes.length) return c;
        var keep = typed();
        if (fromCheckout) {
          codes.forEach(function (k) { if (linked.indexOf(k.toLowerCase()) < 0 && keep.indexOf(k.toLowerCase()) < 0) keep.push(k.toLowerCase()); });
          try { localStorage.setItem(KEY, JSON.stringify(keep.slice(-10))); } catch (e) {}
        }
        var stay = codes.filter(function (k) { return keep.indexOf(k.toLowerCase()) > -1; });
        if (stay.length === codes.length) return c;
        return fetch(ROOT + "cart/update.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: stay.join(",") })
        }).then(function (r) { return r.json(); });
      })
      .catch(function () {});
  }

  var ready = clean();

  /* Before checkout: an app may have applied a code since the page loaded. */
  function goingToCheckout(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin || !/\/checkout\/?$/.test(u.pathname)) return;
    e.preventDefault();
    clean().then(function () { location.href = u.href; });
  }
  document.addEventListener("click", goingToCheckout, true);
  document.addEventListener("submit", function (e) {
    var f = e.target, b = e.submitter;
    if (!f || !f.action || !/\/cart\/?$/.test(f.action.split("?")[0]) || !(b && b.name === "checkout") || f.hasAttribute("data-alm-nocode")) return;
    e.preventDefault();
    clean().then(function () {
      var h = document.createElement("input");
      h.type = "hidden"; h.name = "checkout"; h.value = b.value || "1";
      f.appendChild(h);
      f.setAttribute("data-alm-nocode", "");
      f.submit();
    });
  }, true);

  return { ready: ready, clean: clean };
})();
